import { useState, useRef, useEffect } from "react";

import moment from "moment";
import "../../../receitas/components/filtrosReceitas/FiltrosReceitas.scss";

//MUI
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import OutlinedInput from "@mui/material/OutlinedInput";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
// import SearchIcon from "@mui/icons-material/Search";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import ArticleIcon from "@mui/icons-material/Article";
import SearchIcon from "@mui/icons-material/Search";
///////////
import ModalFiltrosSaidas from "./ModalFiltrosSaidas";

function FiltrosSaida({
  saidasAbsolut,
  saidasParaTextSearch,
  handleFiltrar,
  handleExportar,
  filtrosAplicados,
  filtroCaixa,
  filtroCategoria,
  filtroMetodoPagamento,
  clinicaId,
  auth,
  fetchSaida,
  filtroTextoSearch,
}) {
  const [mostrarDatas, setMostrarDatas] = useState(false);
  const [dataInicial, setDataInicial] = useState(moment().startOf("day"));
  const [dataFinal, setDataFinal] = useState(moment().endOf("day"));
  const [openModalFiltros, setOpenModalFiltros] = useState(false);
  const [textSearchQuery, setTextSearchQuery] = useState("");
  const [filtrosDatas, setFiltrosDatas] = useState({
    dataPagamento: true,
    dataLimitePagamento: true,
    dataCriacao: true,
  });
  const periodoRef = useRef(null);
  const timerRef = useRef(null);
  const datasActivasRef = useRef({ inicio: dataInicial, fim: dataFinal });

  useEffect(() => {
    if (filtroTextoSearch === "") {
      setTextSearchQuery("");
    }
  }, [filtroTextoSearch]);

  useEffect(() => {
    fetchSaida(
      datasActivasRef.current.inicio,
      datasActivasRef.current.fim,
      filtrosDatas,
    );
  }, [filtrosDatas]);

  const fetchByPeriodo = () => {
    const periodo = periodoRef.current.value;
    let startDate;
    let endDate;

    if (periodo === "hoje") {
      startDate = moment();
      endDate = moment();
    }
    if (periodo === "ontem") {
      startDate = moment().subtract(1, "days").startOf("day");
      endDate = moment().subtract(1, "days").endOf("day");
    }
    if (periodo === "semana") {
      startDate = moment().startOf("week");
      endDate = moment().endOf("week");
    }
    if (periodo === "mes") {
      startDate = moment().startOf("month");
      endDate = moment().endOf("month");
    }
    if (periodo === "-mes") {
      startDate = moment().subtract(1, "months").startOf("month");
      endDate = moment().subtract(1, "months").endOf("month");
    }
    if (periodo === "-30d") {
      startDate = moment().startOf("day").subtract(30, "days");
      endDate = moment();
    }
    if (periodo === "+30d") {
      startDate = moment();
      endDate = moment().startOf("day").add(30, "days");
    }
    datasActivasRef.current = { inicio: startDate, fim: endDate };
    fetchSaida(startDate, endDate, filtrosDatas);
  };

  const escolherPeriodoHandler = (e) => {
    if (e.target.value === "periodo" && !mostrarDatas) {
      setMostrarDatas(true);
    } else if (e.target.value !== "periodo") {
      if (mostrarDatas) {
        setMostrarDatas(false);
      }
      fetchByPeriodo();
    }
  };

  const handleCloseModalFiltros = () => {
    setOpenModalFiltros(false);
  };

  const changeDatas = (identificacao, valor) => {
    if (identificacao === "dataInicial") {
      setDataInicial(valor);
      if (valor <= dataFinal) {
        datasActivasRef.current = { inicio: valor, fim: dataFinal };
        fetchSaida(valor, dataFinal, filtrosDatas);
      }
    } else {
      setDataFinal(valor);
      if (valor >= dataInicial) {
        datasActivasRef.current = { inicio: dataInicial, fim: valor };
        fetchSaida(dataInicial, valor, filtrosDatas);
      }
    }
  };

  const applyTextSearchSaidas = (query) => {
    if (query) {
      const lowerCaseText = query.toLowerCase();
      const filteredSaidas = [];

      saidasParaTextSearch.forEach((saida) => {
        if (
          saida.categoria.categoria.toLowerCase().includes(lowerCaseText) ||
          saida.caixa.caixa.toLowerCase().includes(lowerCaseText) ||
          saida.descricao?.toLowerCase().includes(lowerCaseText) ||
          saida.metodoPagamento?.toLowerCase().includes(lowerCaseText) ||
          moment(saida?.dataPagamento)
            .format("DD-MM-YYYY")
            .includes(lowerCaseText) ||
          saida.valor.toString() === lowerCaseText
        )
          filteredSaidas.push({ ...saida });
      });
      return filteredSaidas;
    } else {
      return saidasParaTextSearch;
    }
  };

  const handleTextSearch = (query) => {
    setTextSearchQuery(query);

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      const filteredSaidas = applyTextSearchSaidas(query);
      handleFiltrar(filteredSaidas, [], null, null, null, query, "textSearch");
    }, 500);
  };

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  const handleModalFiltros = (
    filteredSaidas,
    appliedFilters,
    caixa,
    categoria,
    metodoPagamento,
  ) => {
    // Reset text search when modal filters are applied
    setTextSearchQuery("");
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    handleFiltrar(
      filteredSaidas,
      appliedFilters,
      caixa,
      categoria,
      metodoPagamento,
      "",
      "modalFiltros",
    );
  };

  return (
    <div className="financeiro__filtros">
      <span className="financeiro__filtros__texto">Exibindo saídas</span>
      <select name="" id="" onChange={escolherPeriodoHandler} ref={periodoRef}>
        <option value="hoje">de hoje</option>
        <option value="ontem">de ontem</option>
        <option value="semana">dessa semana</option>
        <option value="mes">desse mês</option>
        <option value="-mes">do mês passado</option>
        <option value="-30d">dos últimos 30 dias</option>
        <option value="+30d">dos próximos 30 dias</option>
        <option value="periodo">escolher período</option>
      </select>

      <FormControl size="small" sx={{ minWidth: 160 }}>
        <InputLabel id="filtro-datas-label" sx={{ background: "#fff" }}>
          Filtrar por data
        </InputLabel>
        <Select
          labelId="filtro-datas-label"
          multiple
          value={Object.keys(filtrosDatas).filter((k) => filtrosDatas[k])}
          onChange={(e) => {
            const selected = e.target.value;
            if (selected.length === 0) return;
            setFiltrosDatas({
              dataCriacao: selected.includes("dataCriacao"),
              dataLimitePagamento: selected.includes("dataLimitePagamento"),
              dataPagamento: selected.includes("dataPagamento"),
            });
          }}
          input={<OutlinedInput label="Filtrar por data" />}
          renderValue={(selected) =>
            selected
              .map((s) =>
                s === "dataCriacao"
                  ? "Criação"
                  : s === "dataLimitePagamento"
                    ? "Vencimento"
                    : "Pagamento",
              )
              .join(", ")
          }
        >
          <MenuItem value="dataCriacao">
            <Checkbox checked={filtrosDatas.dataCriacao} />
            <ListItemText primary="Criação" />
          </MenuItem>
          <MenuItem value="dataLimitePagamento">
            <Checkbox checked={filtrosDatas.dataLimitePagamento} />
            <ListItemText primary="Vencimento" />
          </MenuItem>
          <MenuItem value="dataPagamento">
            <Checkbox checked={filtrosDatas.dataPagamento} />
            <ListItemText primary="Pagamento" />
          </MenuItem>
        </Select>
      </FormControl>

      {mostrarDatas && dataInicial && dataFinal && (
        <div className="financeiro__filtros__periodoContainer">
          <div className="financeiro__filtros__periodoContainer__dataInicioContainer financeiro__filtros__periodoContainer__dataContainer">
            <LocalizationProvider
              dateAdapter={AdapterMoment}
              className="adicionar-despesa__modal__container--span1"
            >
              <DesktopDatePicker
                className="valorDataCaixa__fields--field muiDatePicker"
                label="Data Inicial*"
                inputFormat="DD-MM-YYYY"
                renderInput={(params) => <TextField {...params} />}
                onChange={(value) => changeDatas("dataInicial", value)}
                value={dataInicial}
              />
            </LocalizationProvider>
          </div>
          <div className="financeiro__filtros__periodoContainer__dataFimContainer financeiro__filtros__periodoContainer__dataContainer">
            <LocalizationProvider
              dateAdapter={AdapterMoment}
              className="adicionar-despesa__modal__container--span1"
            >
              <DesktopDatePicker
                className="valorDataCaixa__fields--field muiDatePicker"
                label="Data Final*"
                inputFormat="DD-MM-YYYY"
                renderInput={(params) => <TextField {...params} />}
                onChange={(value) => changeDatas("dataFinal", value)}
                value={dataFinal}
              />
            </LocalizationProvider>
          </div>
        </div>
      )}

      <div className="textBoxSearch__container">
        <input
          type="text"
          placeholder="Procurar"
          className="textBoxSearch__input"
          value={textSearchQuery}
          onChange={(e) => handleTextSearch(e.target.value)}
        />
        <SearchIcon className="financeiro__filtros__search-icon" />
      </div>

      <div
        className={`financeiro__filtros__filtrar ${
          (filtrosAplicados && filtrosAplicados.length > 0) ||
          (filtroCaixa && filtroCaixa !== "todas") ||
          (filtroCategoria && filtroCategoria !== "todas") ||
          (filtroMetodoPagamento && filtroMetodoPagamento !== "todas")
            ? "financeiro__filtros__filtrar--ativo"
            : ""
        }`}
        onClick={(e) => setOpenModalFiltros(true)}
      >
        <FilterAltIcon
          className={
            (filtrosAplicados && filtrosAplicados.length > 0) ||
            (filtroCaixa && filtroCaixa !== "todas") ||
            (filtroCategoria && filtroCategoria !== "todas") ||
            (filtroMetodoPagamento && filtroMetodoPagamento !== "todas")
              ? "filtro__ativo financeiro__filtros__icon"
              : "financeiro__filtros__icon"
          }
        />
        <span
          className={
            (filtrosAplicados && filtrosAplicados.length > 0) ||
            (filtroCaixa && filtroCaixa !== "todas") ||
            (filtroCategoria && filtroCategoria !== "todas") ||
            (filtroMetodoPagamento && filtroMetodoPagamento !== "todas")
              ? "filtro__ativo financeiro__filtros__icon-text"
              : "financeiro__filtros__icon-text"
          }
        >
          Filtrar
        </span>
      </div>

      <div className="financeiro__filtros__filtrar" onClick={handleExportar}>
        <ArticleIcon className="financeiro__filtros__icon" />
        <span className="financeiro__filtros__icon-text">Exportar Excel</span>
      </div>

      {openModalFiltros && (
        <ModalFiltrosSaidas
          openModalFiltros={openModalFiltros}
          handleCloseModalFiltros={handleCloseModalFiltros}
          handleFiltrar={handleModalFiltros}
          saidas={saidasAbsolut}
          filtrosAplicados={filtrosAplicados ? filtrosAplicados : []}
          filtroCaixa={filtroCaixa}
          filtroCategoria={filtroCategoria}
          filtroMetodoPagamento={filtroMetodoPagamento}
          clinicaId={clinicaId}
          auth={auth}
        />
      )}
    </div>
  );
}

export default FiltrosSaida;
